<div class="page-body-wrapper">
  <h2 class="page-title">Aktarım İşlemleri</h2>

  <div class="cards-container">

    <!-- Fazla Mesai Aktar -->
    <mat-card class="transfer-card">
      <mat-card-header>
        <mat-icon mat-card-avatar class="card-header-icon">schedule</mat-icon>
        <mat-card-title>Fazla Mesai Aktar</mat-card-title>
        <mat-card-subtitle>Mesai verilerini ERP'ye gönderir</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <mat-form-field appearance="outline" class="period-field">
          <mat-label>Dönem (YYYY-MM)</mat-label>
          <input matInput [(ngModel)]="overtimePeriod" placeholder="2025-01">
        </mat-form-field>
      </mat-card-content>
      <mat-card-actions>
        <button mat-flat-button color="primary"
                (click)="onOvertimeSendErp()"
                [disabled]="overtimeLoading">
          <mat-spinner *ngIf="overtimeLoading" diameter="18" class="btn-spinner"></mat-spinner>
          <mat-icon *ngIf="!overtimeLoading">send</mat-icon>
          {{ overtimeLoading ? 'Gönderiliyor...' : 'Fazla Mesai Aktar' }}
        </button>
      </mat-card-actions>
    </mat-card>

    <!-- Tedarikçi İçeri Al -->
    <mat-card class="transfer-card">
      <mat-card-header>
        <mat-icon mat-card-avatar class="card-header-icon">business</mat-icon>
        <mat-card-title>Tedarikçi İçeri Al</mat-card-title>
        <mat-card-subtitle>ERP'den tedarikçileri çeker ve portale aktarır</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <p class="step-info">
          <strong>Adım 1:</strong> ERP'den tedarikçi bilgileri çekilir<br>
          <strong>Adım 2:</strong> Yeni tedarikçiler portale aktarılır
        </p>
      </mat-card-content>
      <mat-card-actions>
        <button mat-flat-button color="accent"
                (click)="onVendorSync()"
                [disabled]="vendorStep1Loading || vendorStep2Loading">
          <mat-spinner *ngIf="vendorStep1Loading || vendorStep2Loading" diameter="18" class="btn-spinner"></mat-spinner>
          <mat-icon *ngIf="!vendorStep1Loading && !vendorStep2Loading">sync</mat-icon>
          <span *ngIf="vendorStep1Loading">Tedarikçiler Çekiliyor...</span>
          <span *ngIf="vendorStep2Loading">Tedarikçiler Aktarılıyor...</span>
          <span *ngIf="!vendorStep1Loading && !vendorStep2Loading">Tedarikçi İçeri Al</span>
        </button>
      </mat-card-actions>
    </mat-card>

    <!-- Item İçeri Al -->
    <mat-card class="transfer-card">
      <mat-card-header>
        <mat-icon mat-card-avatar class="card-header-icon">inventory_2</mat-icon>
        <mat-card-title>Item İçeri Al</mat-card-title>
        <mat-card-subtitle>ERP'den kalemleri çeker ve portale aktarır</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <p class="step-info">
          <strong>Adım 1:</strong> ERP'den kalem bilgileri çekilir<br>
          <strong>Adım 2:</strong> Yeni kalemler portale aktarılır
        </p>
      </mat-card-content>
      <mat-card-actions>
        <button mat-flat-button color="accent"
                (click)="onItemSync()"
                [disabled]="itemStep1Loading || itemStep2Loading">
          <mat-spinner *ngIf="itemStep1Loading || itemStep2Loading" diameter="18" class="btn-spinner"></mat-spinner>
          <mat-icon *ngIf="!itemStep1Loading && !itemStep2Loading">sync</mat-icon>
          <span *ngIf="itemStep1Loading">Kalemler Çekiliyor...</span>
          <span *ngIf="itemStep2Loading">Kalemler Aktarılıyor...</span>
          <span *ngIf="!itemStep1Loading && !itemStep2Loading">Item İçeri Al</span>
        </button>
      </mat-card-actions>
    </mat-card>

  </div>
</div>
